var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 64,
    viewBox: "0 0 63.5 16.933",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "img"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -280.07)",
    id: "g70"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.029243 0 0 .029243 -33.538 280.59)",
    id: "g34"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 836.2,
    height: 609.5,
    fill: "#fff",
    id: "rect2"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.181 0 0 1.181 975.52 -89.456)",
    id: "g10"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m356.2 448.9c-58.9-10.3-103.9-61.8-103.9-123.6v-147.2h-43.3v147.2c0 93.1 75.7 168.8 168.8 168.8h21.6v-244.4h-43.3v199.2z",
    fill: "#113652",
    id: "path4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m579.9 315v10.2c0 61.8-44.9 113.4-103.9 123.6v-177.6c0.5-7.5 1.4-42.1-22-67.7-14.3-15.7-34.1-24.3-58.8-25.4h-112.5v61.3h43.3v-18h63.5c14.8 0 25.4 3.7 32.4 11.2 10.5 11.3 11.1 29.1 11 34.4h-0.1v227h21.6c93.1 0 168.8-75.7 168.8-168.8v-10.2z",
    fill: "#113652",
    id: "path6"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "585.4 164.8 623.1 164.8 623.1 121.4 579.8 121.4 579.8 151.7 546.8 178.1 537.3 178.1 494 178.1 488.9 178.1 488.9 239.4 546.8 239.4 579.8 265.8 579.8 296 623.1 296 623.1 252.7 585.4 252.7 550.2 224.5 550.2 192.9",
    fill: "#5fa2dd",
    id: "polygon8",
    style: {
      fill: "#00a0c6",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(34.197 0 0 34.197 -233.22 -3149.9)",
    id: "g32"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.091056 0 0 .091056 42.022 68.887)",
    id: "g30"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m226.8 382-8.4 15.9c-0.5 1-1.2 1.7-2.1 2.2-0.8 0.5-1.8 0.7-2.8 0.7-2.2 0-3.8-1-4.9-3l-28.1-52h11.3l21.9 41.7 8.2-14.8-14.1-27h11.4l21 41.7 22.1-41.7h10.7l-28.1 52c-0.5 1-1.3 1.7-2.1 2.2-0.9 0.5-1.8 0.7-2.8 0.7s-1.9-0.2-2.8-0.7c-0.8-0.5-1.5-1.2-2.1-2.2z",
    fill: "#113652",
    id: "path12"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m275.7 400.2v-54.3h9.5v54.3z",
    fill: "#113652",
    id: "path14"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m291.3 400.2v-54.3h9.5v44.8h36.5v9.5z",
    fill: "#113652",
    id: "path16"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m340.4 400.2v-54.3h9.5v44.8h36.5v9.5z",
    fill: "#113652",
    id: "path18"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m403.1 400.2v-20.6l-28.8-33.7h12.7l21.1 25 21.2-25h12.1l-28.9 33.7v20.6z",
    fill: "#113652",
    id: "path20"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m460.8 400.2v-44.8h-20.6v-9.5h50.7v9.5h-20.6v44.8z",
    fill: "#5fa2dd",
    id: "path22",
    style: {
      fill: "#00a0c6",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m493.4 400.2v-54.3h48.5v9.5h-39v35.3h39.1v9.5zm16.4-23.6v-8h30.1v8z",
    fill: "#5fa2dd",
    id: "path24",
    style: {
      fill: "#00a0c6",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m571.2 400.2c-3.8 0-7.3-0.7-10.5-2.1s-6-3.4-8.4-5.8c-2.4-2.5-4.2-5.4-5.5-8.8s-2-7-2-11 0.7-7.6 2-10.9 3.2-6.1 5.5-8.4c2.4-2.3 5.2-4.1 8.4-5.4s6.7-1.9 10.5-1.9h29.4v9.5h-29.4c-2.4 0-4.7 0.4-6.8 1.3s-3.8 2.1-5.3 3.6-2.7 3.4-3.5 5.5-1.3 4.5-1.3 7.1c0 2.5 0.4 4.9 1.3 7.1 0.8 2.2 2 4.1 3.5 5.6s3.3 2.8 5.3 3.7c2.1 0.9 4.3 1.3 6.8 1.3h29.4v9.5h-29.4z",
    fill: "#5fa2dd",
    id: "path26",
    style: {
      fill: "#00a0c6",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m604.5 400.4v-54.5h9.5v54.5zm43.7 0v-23.6h-27.3v-8.4h27.3v-22.5h9.5v54.5z",
    fill: "#5fa2dd",
    id: "path28",
    style: {
      fill: "#00a0c6",
      fillOpacity: 1
    }
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.029243 0 0 .029243 -33.538 280.59)",
    display: "none",
    id: "g68"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 836.2,
    height: 609.5,
    fill: "#fff",
    id: "rect36"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.181 0 0 1.181 975.52 -89.456)",
    id: "g44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m356.2 448.9c-58.9-10.3-103.9-61.8-103.9-123.6v-147.2h-43.3v147.2c0 93.1 75.7 168.8 168.8 168.8h21.6v-244.4h-43.3v199.2z",
    fill: "#113652",
    id: "path38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m579.9 315v10.2c0 61.8-44.9 113.4-103.9 123.6v-177.6c0.5-7.5 1.4-42.1-22-67.7-14.3-15.7-34.1-24.3-58.8-25.4h-112.5v61.3h43.3v-18h63.5c14.8 0 25.4 3.7 32.4 11.2 10.5 11.3 11.1 29.1 11 34.4h-0.1v227h21.6c93.1 0 168.8-75.7 168.8-168.8v-10.2z",
    fill: "#113652",
    id: "path40"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "537.3 178.1 494 178.1 488.9 178.1 488.9 239.4 546.8 239.4 579.8 265.8 579.8 296 623.1 296 623.1 252.7 585.4 252.7 550.2 224.5 550.2 192.9 585.4 164.8 623.1 164.8 623.1 121.4 579.8 121.4 579.8 151.7 546.8 178.1",
    fill: "#00a0c6",
    id: "polygon42"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(34.197 0 0 34.197 -233.22 -3149.9)",
    id: "g66"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.091056 0 0 .091056 42.022 68.887)",
    display: "inline",
    id: "g64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m226.8 382-8.4 15.9c-0.5 1-1.2 1.7-2.1 2.2-0.8 0.5-1.8 0.7-2.8 0.7-2.2 0-3.8-1-4.9-3l-28.1-52h11.3l21.9 41.7 8.2-14.8-14.1-27h11.4l21 41.7 22.1-41.7h10.7l-28.1 52c-0.5 1-1.3 1.7-2.1 2.2-0.9 0.5-1.8 0.7-2.8 0.7s-1.9-0.2-2.8-0.7c-0.8-0.5-1.5-1.2-2.1-2.2z",
    fill: "#113652",
    id: "path46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m275.7 400.2v-54.3h9.5v54.3z",
    fill: "#113652",
    id: "path48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m291.3 400.2v-54.3h9.5v44.8h36.5v9.5z",
    fill: "#113652",
    id: "path50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m340.4 400.2v-54.3h9.5v44.8h36.5v9.5z",
    fill: "#113652",
    id: "path52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m403.1 400.2v-20.6l-28.8-33.7h12.7l21.1 25 21.2-25h12.1l-28.9 33.7v20.6z",
    fill: "#113652",
    id: "path54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m460.8 400.2v-44.8h-20.6v-9.5h50.7v9.5h-20.6v44.8z",
    fill: "#00a0c6",
    id: "path56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m493.4 400.2v-54.3h48.5v9.5h-39v35.3h39.1v9.5zm16.4-23.6v-8h30.1v8z",
    fill: "#00a0c6",
    id: "path58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m571.2 400.2c-3.8 0-7.3-0.7-10.5-2.1s-6-3.4-8.4-5.8c-2.4-2.5-4.2-5.4-5.5-8.8s-2-7-2-11 0.7-7.6 2-10.9 3.2-6.1 5.5-8.4c2.4-2.3 5.2-4.1 8.4-5.4s6.7-1.9 10.5-1.9h29.4v9.5h-29.4c-2.4 0-4.7 0.4-6.8 1.3s-3.8 2.1-5.3 3.6-2.7 3.4-3.5 5.5-1.3 4.5-1.3 7.1c0 2.5 0.4 4.9 1.3 7.1 0.8 2.2 2 4.1 3.5 5.6s3.3 2.8 5.3 3.7c2.1 0.9 4.3 1.3 6.8 1.3h29.4v9.5h-29.4z",
    fill: "#00a0c6",
    id: "path60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m604.5 400.4v-54.5h9.5v54.5zm43.7 0v-23.6h-27.3v-8.4h27.3v-22.5h9.5v54.5z",
    fill: "#00a0c6",
    id: "path62"
  })))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    display: "none",
    id: "g80"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.13607 0 0 .13607 2.3996 -47.529)",
    display: "inline",
    id: "g78"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m399.4 293.7c-19.8-3.5-34.9-20.8-34.9-41.6v-49.5h-14.6v49.5c0 31.3 25.5 56.8 56.8 56.8h7.3v-82.2h-14.6z",
    fill: "#113652",
    id: "path72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m474.6 248.7v3.4c0 20.8-15.1 38.1-34.9 41.6v-59.7c0.2-2.5 0.5-14.2-7.4-22.8-4.8-5.3-11.5-8.2-19.8-8.6h-37.8v20.6h14.6v-6.1h21.3c5 0 8.6 1.2 10.9 3.8 3.5 3.8 3.7 9.8 3.7 11.6v76.3h7.3c31.3 0 56.8-25.5 56.8-56.8v-3.4h-14.7z",
    fill: "#113652",
    id: "path74"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "444 202.7 444 223.3 463.5 223.3 474.6 232.2 474.6 242.3 489.1 242.3 489.1 227.8 476.4 227.8 464.6 218.3 464.6 207.7 476.4 198.2 489.1 198.2 489.1 183.6 474.6 183.6 474.6 193.8 463.5 202.7 460.3 202.7 445.7 202.7",
    fill: "#00a0c6",
    id: "polygon76"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.3a5e462191ad7f48ceeaf2c761511085.svg";
export { ForwardRef as ReactComponent };